<template src="./Details.html">
</template>

<script>
export default {
        props: {
            itemId: {
                type: Number,
                required: true,
            },
        },

        created() {
            this.$store
                .dispatch("directorsAppointments/getDetails", this.itemId)
                .then(() => {

                })
                .catch(() => { });
        },
  computed: {
      directorsAppointment() {
          return this.$store.state.directorsAppointments.directorsAppointment;
      }
  },
};
</script>